
export const BASE_URL =  process.env.REACT_APP_BACKEND_URL
export const PUBLISHABLE_KEY =  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
export const WEBSOCKET_BASE_URL =  process.env.REACT_APP_WS_BACKEND_URL